export default __webpack_public_path__ + "static/media/unexpand-tree-table-icon.1f7b54db.svg";